import PageRoutes from '../pages/config/routes';

const routes = ([
  PageRoutes,
]);

export default routes;
